/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface IdentityVerificationRequestStatus {
  readonly status: string;
  readonly verificationInProgress: boolean;
}

@Injectable({ providedIn: 'root' })
export class IdentityVerificationPersonaService {
  constructor(private http: HttpClient) {}

  isVerificationRequested(): Observable<boolean> {
    return this.http.get<IdentityVerificationRequestStatus>('/api/v1/identity-verification/request-status').pipe(
      map(response => response.status === 'REQUESTED' && !response.verificationInProgress),
      catchError(() => of(false)),
    );
  }
}
